import { core_v1_DataSourceSpec } from '@antimatterhq/asl-api-ts-v1';
import { Fieldset } from '@antimatterhq/ui/components/fieldset';
import Spacer from '@antimatterhq/ui/components/spacer';

type BronzeTables = NonNullable<
  core_v1_DataSourceSpec['silver']
>['bronzeTables'];

export const BronzeTablesReview = ({
  bronzeTables = [],
}: {
  bronzeTables: BronzeTables;
}) => {
  return (
    <div>
      <Fieldset.Field>
        <Fieldset.Label>Additional bronze table(s):</Fieldset.Label>
      </Fieldset.Field>
      <Fieldset.List>
        {bronzeTables?.map((table, i) => (
          <div key={table.name}>
            {i !== 0 && <Spacer size="lg" />}
            <Fieldset.Field>
              <Fieldset.Label>Name:</Fieldset.Label>
              <Fieldset.Value>{table.name}</Fieldset.Value>
            </Fieldset.Field>
            <Fieldset.Field>
              <Fieldset.Label>Streaming:</Fieldset.Label>
              <Fieldset.Value>{table.streaming ? 'yes' : 'no'}</Fieldset.Value>
            </Fieldset.Field>
            {table.streaming && (
              <>
                <Fieldset.Field>
                  <Fieldset.Label>Event time column:</Fieldset.Label>
                  <Fieldset.Value>
                    {table.watermark?.eventTimeColumn}
                  </Fieldset.Value>
                </Fieldset.Field>
                <Fieldset.Field>
                  <Fieldset.Label>Delay threshold:</Fieldset.Label>
                  <Fieldset.Value>
                    {table.watermark?.delayThreshold}
                  </Fieldset.Value>
                </Fieldset.Field>
                <Fieldset.Field>
                  <Fieldset.Label>Group by and drop duplicates:</Fieldset.Label>
                  <Fieldset.Value>
                    {table.watermark?.dropDuplicates?.map((f) => f).join(', ')}
                  </Fieldset.Value>
                </Fieldset.Field>
              </>
            )}
            <Fieldset.Field>
              <Fieldset.Label>Table alias:</Fieldset.Label>
              <Fieldset.Value>{table.alias}</Fieldset.Value>
            </Fieldset.Field>
            <Fieldset.Field>
              <Fieldset.Label>Join type:</Fieldset.Label>
              <Fieldset.Value>{table.joinType}</Fieldset.Value>
            </Fieldset.Field>
            <Fieldset.Field>
              <Fieldset.Label>Join expression:</Fieldset.Label>
              <Fieldset.Value>{table.joinExpr}</Fieldset.Value>
            </Fieldset.Field>
          </div>
        ))}
      </Fieldset.List>
    </div>
  );
};
